function cov_15r8fybm8s() {
  var path = "/codebuild/output/src315236701/src/src/common/store/editor.ts";
  var hash = "4271894c242b18a8e9ae06f90eb2f68a5b2045de";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/store/editor.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 30
        },
        end: {
          line: 236,
          column: 2
        }
      },
      "1": {
        start: {
          line: 6,
          column: 18
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "2": {
        start: {
          line: 71,
          column: 65
        },
        end: {
          line: 71,
          column: 70
        }
      },
      "3": {
        start: {
          line: 72,
          column: 26
        },
        end: {
          line: 72,
          column: 88
        }
      },
      "4": {
        start: {
          line: 72,
          column: 70
        },
        end: {
          line: 72,
          column: 87
        }
      },
      "5": {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 88
        }
      },
      "6": {
        start: {
          line: 73,
          column: 70
        },
        end: {
          line: 73,
          column: 87
        }
      },
      "7": {
        start: {
          line: 74,
          column: 12
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "8": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 114
        }
      },
      "9": {
        start: {
          line: 83,
          column: 33
        },
        end: {
          line: 83,
          column: 50
        }
      },
      "10": {
        start: {
          line: 84,
          column: 30
        },
        end: {
          line: 84,
          column: 59
        }
      },
      "11": {
        start: {
          line: 86,
          column: 29
        },
        end: {
          line: 86,
          column: 146
        }
      },
      "12": {
        start: {
          line: 86,
          column: 142
        },
        end: {
          line: 86,
          column: 144
        }
      },
      "13": {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 87,
          column: 40
        }
      },
      "14": {
        start: {
          line: 92,
          column: 26
        },
        end: {
          line: 92,
          column: 90
        }
      },
      "15": {
        start: {
          line: 92,
          column: 68
        },
        end: {
          line: 92,
          column: 89
        }
      },
      "16": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 95,
          column: 13
        }
      },
      "17": {
        start: {
          line: 94,
          column: 16
        },
        end: {
          line: 94,
          column: 55
        }
      },
      "18": {
        start: {
          line: 96,
          column: 12
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "19": {
        start: {
          line: 99,
          column: 26
        },
        end: {
          line: 99,
          column: 90
        }
      },
      "20": {
        start: {
          line: 99,
          column: 68
        },
        end: {
          line: 99,
          column: 89
        }
      },
      "21": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 102,
          column: 13
        }
      },
      "22": {
        start: {
          line: 101,
          column: 16
        },
        end: {
          line: 101,
          column: 55
        }
      },
      "23": {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 105,
          column: 39
        }
      },
      "24": {
        start: {
          line: 108,
          column: 23
        },
        end: {
          line: 108,
          column: 31
        }
      },
      "25": {
        start: {
          line: 109,
          column: 12
        },
        end: {
          line: 112,
          column: 14
        }
      },
      "26": {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 113,
          column: 22
        }
      },
      "27": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 117,
          column: 38
        }
      },
      "28": {
        start: {
          line: 117,
          column: 16
        },
        end: {
          line: 117,
          column: 38
        }
      },
      "29": {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 118,
          column: 33
        }
      },
      "30": {
        start: {
          line: 121,
          column: 33
        },
        end: {
          line: 121,
          column: 64
        }
      },
      "31": {
        start: {
          line: 121,
          column: 57
        },
        end: {
          line: 121,
          column: 63
        }
      },
      "32": {
        start: {
          line: 122,
          column: 33
        },
        end: {
          line: 122,
          column: 64
        }
      },
      "33": {
        start: {
          line: 122,
          column: 57
        },
        end: {
          line: 122,
          column: 63
        }
      },
      "34": {
        start: {
          line: 123,
          column: 25
        },
        end: {
          line: 123,
          column: 50
        }
      },
      "35": {
        start: {
          line: 124,
          column: 26
        },
        end: {
          line: 124,
          column: 51
        }
      },
      "36": {
        start: {
          line: 125,
          column: 27
        },
        end: {
          line: 125,
          column: 39
        }
      },
      "37": {
        start: {
          line: 126,
          column: 24
        },
        end: {
          line: 126,
          column: 49
        }
      },
      "38": {
        start: {
          line: 127,
          column: 27
        },
        end: {
          line: 127,
          column: 52
        }
      },
      "39": {
        start: {
          line: 128,
          column: 28
        },
        end: {
          line: 128,
          column: 40
        }
      },
      "40": {
        start: {
          line: 129,
          column: 12
        },
        end: {
          line: 129,
          column: 63
        }
      },
      "41": {
        start: {
          line: 132,
          column: 12
        },
        end: {
          line: 133,
          column: 23
        }
      },
      "42": {
        start: {
          line: 133,
          column: 16
        },
        end: {
          line: 133,
          column: 23
        }
      },
      "43": {
        start: {
          line: 134,
          column: 12
        },
        end: {
          line: 135,
          column: 23
        }
      },
      "44": {
        start: {
          line: 135,
          column: 16
        },
        end: {
          line: 135,
          column: 23
        }
      },
      "45": {
        start: {
          line: 136,
          column: 34
        },
        end: {
          line: 136,
          column: 59
        }
      },
      "46": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 60
        }
      },
      "47": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 51
        }
      },
      "48": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 51
        }
      },
      "49": {
        start: {
          line: 145,
          column: 36
        },
        end: {
          line: 145,
          column: 78
        }
      },
      "50": {
        start: {
          line: 146,
          column: 27
        },
        end: {
          line: 146,
          column: 51
        }
      },
      "51": {
        start: {
          line: 147,
          column: 41
        },
        end: {
          line: 147,
          column: 64
        }
      },
      "52": {
        start: {
          line: 148,
          column: 12
        },
        end: {
          line: 148,
          column: 76
        }
      },
      "53": {
        start: {
          line: 152,
          column: 36
        },
        end: {
          line: 152,
          column: 78
        }
      },
      "54": {
        start: {
          line: 153,
          column: 27
        },
        end: {
          line: 153,
          column: 52
        }
      },
      "55": {
        start: {
          line: 154,
          column: 41
        },
        end: {
          line: 154,
          column: 64
        }
      },
      "56": {
        start: {
          line: 155,
          column: 12
        },
        end: {
          line: 155,
          column: 76
        }
      },
      "57": {
        start: {
          line: 158,
          column: 12
        },
        end: {
          line: 158,
          column: 44
        }
      },
      "58": {
        start: {
          line: 159,
          column: 12
        },
        end: {
          line: 159,
          column: 44
        }
      },
      "59": {
        start: {
          line: 162,
          column: 35
        },
        end: {
          line: 162,
          column: 56
        }
      },
      "60": {
        start: {
          line: 164,
          column: 12
        },
        end: {
          line: 166,
          column: 15
        }
      },
      "61": {
        start: {
          line: 165,
          column: 16
        },
        end: {
          line: 165,
          column: 46
        }
      },
      "62": {
        start: {
          line: 168,
          column: 31
        },
        end: {
          line: 173,
          column: 19
        }
      },
      "63": {
        start: {
          line: 169,
          column: 33
        },
        end: {
          line: 169,
          column: 91
        }
      },
      "64": {
        start: {
          line: 170,
          column: 39
        },
        end: {
          line: 173,
          column: 13
        }
      },
      "65": {
        start: {
          line: 174,
          column: 12
        },
        end: {
          line: 174,
          column: 36
        }
      },
      "66": {
        start: {
          line: 177,
          column: 38
        },
        end: {
          line: 177,
          column: 83
        }
      },
      "67": {
        start: {
          line: 178,
          column: 32
        },
        end: {
          line: 178,
          column: 33
        }
      },
      "68": {
        start: {
          line: 179,
          column: 36
        },
        end: {
          line: 179,
          column: 84
        }
      },
      "69": {
        start: {
          line: 180,
          column: 36
        },
        end: {
          line: 180,
          column: 84
        }
      },
      "70": {
        start: {
          line: 181,
          column: 40
        },
        end: {
          line: 181,
          column: 42
        }
      },
      "71": {
        start: {
          line: 182,
          column: 40
        },
        end: {
          line: 182,
          column: 42
        }
      },
      "72": {
        start: {
          line: 183,
          column: 31
        },
        end: {
          line: 183,
          column: 43
        }
      },
      "73": {
        start: {
          line: 184,
          column: 30
        },
        end: {
          line: 184,
          column: 44
        }
      },
      "74": {
        start: {
          line: 185,
          column: 33
        },
        end: {
          line: 185,
          column: 34
        }
      },
      "75": {
        start: {
          line: 186,
          column: 33
        },
        end: {
          line: 186,
          column: 47
        }
      },
      "76": {
        start: {
          line: 187,
          column: 30
        },
        end: {
          line: 187,
          column: 41
        }
      },
      "77": {
        start: {
          line: 188,
          column: 31
        },
        end: {
          line: 188,
          column: 44
        }
      },
      "78": {
        start: {
          line: 189,
          column: 33
        },
        end: {
          line: 189,
          column: 34
        }
      },
      "79": {
        start: {
          line: 190,
          column: 32
        },
        end: {
          line: 190,
          column: 45
        }
      },
      "80": {
        start: {
          line: 192,
          column: 12
        },
        end: {
          line: 202,
          column: 15
        }
      },
      "81": {
        start: {
          line: 193,
          column: 34
        },
        end: {
          line: 193,
          column: 54
        }
      },
      "82": {
        start: {
          line: 194,
          column: 16
        },
        end: {
          line: 201,
          column: 19
        }
      },
      "83": {
        start: {
          line: 195,
          column: 20
        },
        end: {
          line: 200,
          column: 23
        }
      },
      "84": {
        start: {
          line: 196,
          column: 37
        },
        end: {
          line: 196,
          column: 67
        }
      },
      "85": {
        start: {
          line: 197,
          column: 24
        },
        end: {
          line: 199,
          column: 25
        }
      },
      "86": {
        start: {
          line: 198,
          column: 28
        },
        end: {
          line: 198,
          column: 104
        }
      },
      "87": {
        start: {
          line: 204,
          column: 12
        },
        end: {
          line: 214,
          column: 15
        }
      },
      "88": {
        start: {
          line: 205,
          column: 34
        },
        end: {
          line: 205,
          column: 54
        }
      },
      "89": {
        start: {
          line: 206,
          column: 16
        },
        end: {
          line: 213,
          column: 19
        }
      },
      "90": {
        start: {
          line: 207,
          column: 20
        },
        end: {
          line: 212,
          column: 23
        }
      },
      "91": {
        start: {
          line: 208,
          column: 37
        },
        end: {
          line: 208,
          column: 67
        }
      },
      "92": {
        start: {
          line: 209,
          column: 24
        },
        end: {
          line: 211,
          column: 25
        }
      },
      "93": {
        start: {
          line: 210,
          column: 28
        },
        end: {
          line: 210,
          column: 104
        }
      },
      "94": {
        start: {
          line: 215,
          column: 12
        },
        end: {
          line: 215,
          column: 59
        }
      },
      "95": {
        start: {
          line: 216,
          column: 12
        },
        end: {
          line: 216,
          column: 59
        }
      },
      "96": {
        start: {
          line: 225,
          column: 12
        },
        end: {
          line: 233,
          column: 13
        }
      },
      "97": {
        start: {
          line: 226,
          column: 16
        },
        end: {
          line: 226,
          column: 46
        }
      },
      "98": {
        start: {
          line: 229,
          column: 16
        },
        end: {
          line: 232,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 12
          }
        },
        loc: {
          start: {
            line: 6,
            column: 18
          },
          end: {
            line: 67,
            column: 5
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 9
          }
        },
        loc: {
          start: {
            line: 70,
            column: 43
          },
          end: {
            line: 75,
            column: 9
          }
        },
        line: 70
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 50
          },
          end: {
            line: 72,
            column: 51
          }
        },
        loc: {
          start: {
            line: 72,
            column: 70
          },
          end: {
            line: 72,
            column: 87
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 51
          }
        },
        loc: {
          start: {
            line: 73,
            column: 70
          },
          end: {
            line: 73,
            column: 87
          }
        },
        line: 73
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        },
        loc: {
          start: {
            line: 77,
            column: 19
          },
          end: {
            line: 79,
            column: 9
          }
        },
        line: 77
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        },
        loc: {
          start: {
            line: 82,
            column: 27
          },
          end: {
            line: 88,
            column: 9
          }
        },
        line: 82
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 135
          },
          end: {
            line: 86,
            column: 136
          }
        },
        loc: {
          start: {
            line: 86,
            column: 142
          },
          end: {
            line: 86,
            column: 144
          }
        },
        line: 86
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 9
          }
        },
        loc: {
          start: {
            line: 89,
            column: 27
          },
          end: {
            line: 97,
            column: 9
          }
        },
        line: 89
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 92,
            column: 58
          },
          end: {
            line: 92,
            column: 59
          }
        },
        loc: {
          start: {
            line: 92,
            column: 68
          },
          end: {
            line: 92,
            column: 89
          }
        },
        line: 92
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        loc: {
          start: {
            line: 98,
            column: 30
          },
          end: {
            line: 103,
            column: 9
          }
        },
        line: 98
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 99,
            column: 58
          },
          end: {
            line: 99,
            column: 59
          }
        },
        loc: {
          start: {
            line: 99,
            column: 68
          },
          end: {
            line: 99,
            column: 89
          }
        },
        line: 99
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        },
        loc: {
          start: {
            line: 104,
            column: 30
          },
          end: {
            line: 106,
            column: 9
          }
        },
        line: 104
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 9
          }
        },
        loc: {
          start: {
            line: 107,
            column: 20
          },
          end: {
            line: 114,
            column: 9
          }
        },
        line: 107
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 9
          }
        },
        loc: {
          start: {
            line: 115,
            column: 22
          },
          end: {
            line: 119,
            column: 9
          }
        },
        line: 115
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        loc: {
          start: {
            line: 120,
            column: 46
          },
          end: {
            line: 130,
            column: 9
          }
        },
        line: 120
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 121,
            column: 47
          },
          end: {
            line: 121,
            column: 48
          }
        },
        loc: {
          start: {
            line: 121,
            column: 57
          },
          end: {
            line: 121,
            column: 63
          }
        },
        line: 121
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 122,
            column: 47
          },
          end: {
            line: 122,
            column: 48
          }
        },
        loc: {
          start: {
            line: 122,
            column: 57
          },
          end: {
            line: 122,
            column: 63
          }
        },
        line: 122
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 9
          }
        },
        loc: {
          start: {
            line: 131,
            column: 37
          },
          end: {
            line: 138,
            column: 9
          }
        },
        line: 131
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 9
          }
        },
        loc: {
          start: {
            line: 139,
            column: 48
          },
          end: {
            line: 142,
            column: 9
          }
        },
        line: 139
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        },
        loc: {
          start: {
            line: 144,
            column: 42
          },
          end: {
            line: 149,
            column: 9
          }
        },
        line: 144
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 151,
            column: 8
          },
          end: {
            line: 151,
            column: 9
          }
        },
        loc: {
          start: {
            line: 151,
            column: 42
          },
          end: {
            line: 156,
            column: 9
          }
        },
        line: 151
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 157,
            column: 9
          }
        },
        loc: {
          start: {
            line: 157,
            column: 32
          },
          end: {
            line: 160,
            column: 9
          }
        },
        line: 157
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 9
          }
        },
        loc: {
          start: {
            line: 161,
            column: 43
          },
          end: {
            line: 175,
            column: 9
          }
        },
        line: 161
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 164,
            column: 39
          },
          end: {
            line: 164,
            column: 40
          }
        },
        loc: {
          start: {
            line: 164,
            column: 51
          },
          end: {
            line: 166,
            column: 13
          }
        },
        line: 164
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 169,
            column: 24
          },
          end: {
            line: 169,
            column: 25
          }
        },
        loc: {
          start: {
            line: 169,
            column: 33
          },
          end: {
            line: 169,
            column: 91
          }
        },
        line: 169
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 170,
            column: 24
          },
          end: {
            line: 170,
            column: 25
          }
        },
        loc: {
          start: {
            line: 170,
            column: 39
          },
          end: {
            line: 173,
            column: 13
          }
        },
        line: 170
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 176,
            column: 9
          }
        },
        loc: {
          start: {
            line: 176,
            column: 52
          },
          end: {
            line: 217,
            column: 9
          }
        },
        line: 176
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 192,
            column: 49
          },
          end: {
            line: 192,
            column: 50
          }
        },
        loc: {
          start: {
            line: 192,
            column: 58
          },
          end: {
            line: 202,
            column: 13
          }
        },
        line: 192
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 194,
            column: 47
          },
          end: {
            line: 194,
            column: 48
          }
        },
        loc: {
          start: {
            line: 194,
            column: 54
          },
          end: {
            line: 201,
            column: 17
          }
        },
        line: 194
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 195,
            column: 68
          },
          end: {
            line: 195,
            column: 69
          }
        },
        loc: {
          start: {
            line: 195,
            column: 79
          },
          end: {
            line: 200,
            column: 21
          }
        },
        line: 195
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 204,
            column: 49
          },
          end: {
            line: 204,
            column: 50
          }
        },
        loc: {
          start: {
            line: 204,
            column: 58
          },
          end: {
            line: 214,
            column: 13
          }
        },
        line: 204
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 206,
            column: 47
          },
          end: {
            line: 206,
            column: 48
          }
        },
        loc: {
          start: {
            line: 206,
            column: 54
          },
          end: {
            line: 213,
            column: 17
          }
        },
        line: 206
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 207,
            column: 68
          },
          end: {
            line: 207,
            column: 69
          }
        },
        loc: {
          start: {
            line: 207,
            column: 79
          },
          end: {
            line: 212,
            column: 21
          }
        },
        line: 207
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 224,
            column: 9
          }
        },
        loc: {
          start: {
            line: 224,
            column: 46
          },
          end: {
            line: 234,
            column: 9
          }
        },
        line: 224
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 93,
            column: 12
          },
          end: {
            line: 95,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 12
          },
          end: {
            line: 95,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "1": {
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 102,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 102,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 100
      },
      "2": {
        loc: {
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 117,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 117,
            column: 38
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 116
      },
      "3": {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 133,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 133,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "4": {
        loc: {
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 135,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 135,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 134
      },
      "5": {
        loc: {
          start: {
            line: 134,
            column: 16
          },
          end: {
            line: 134,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 16
          },
          end: {
            line: 134,
            column: 33
          }
        }, {
          start: {
            line: 134,
            column: 37
          },
          end: {
            line: 134,
            column: 63
          }
        }],
        line: 134
      },
      "6": {
        loc: {
          start: {
            line: 174,
            column: 19
          },
          end: {
            line: 174,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 19
          },
          end: {
            line: 174,
            column: 29
          }
        }, {
          start: {
            line: 174,
            column: 33
          },
          end: {
            line: 174,
            column: 35
          }
        }],
        line: 174
      },
      "7": {
        loc: {
          start: {
            line: 197,
            column: 24
          },
          end: {
            line: 199,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 24
          },
          end: {
            line: 199,
            column: 25
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 197
      },
      "8": {
        loc: {
          start: {
            line: 209,
            column: 24
          },
          end: {
            line: 211,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 24
          },
          end: {
            line: 211,
            column: 25
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 209
      },
      "9": {
        loc: {
          start: {
            line: 225,
            column: 12
          },
          end: {
            line: 233,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 12
          },
          end: {
            line: 233,
            column: 13
          }
        }, {
          start: {
            line: 228,
            column: 17
          },
          end: {
            line: 233,
            column: 13
          }
        }],
        line: 225
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/store/editor.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/src/common/store/editor.ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,MAAM,EAAE,MAAM,QAAQ,CAAC;AAChC,OAAO,EAAE,WAAW,EAAE,MAAM,OAAO,CAAC;AACpC,OAAO,EAAE,QAAQ,EAAE,MAAM,wBAAwB,CAAC;AAElD,OAAO,EAAE,eAAe,EAAE,MAAM,WAAW,CAAC;AAe5C,MAAM,CAAC,MAAM,cAAc,GAAG,WAAW,CAAC,QAAQ,EAAE;IAClD,KAAK,EAAE,GAAG,EAAE,CAAC,CAAC;QACZ,IAAI,EAAE,EAA6B;QACnC,KAAK,EAAE,EAAE;QACT,WAAW,EAAE,EAAE;QACf,gBAAgB,EAAE,EAAE;QACpB,SAAS,EAAE,CAAC;QACZ,YAAY,EAAE;YACZ,IAAI,EAAE,KAAK;YACX,GAAG,EAAE,KAAK;YACV,IAAI,EAAE,KAAK;YACX,MAAM,EAAE,KAAK;YACb,SAAS,EAAE,KAAK;YAChB,OAAO,EAAE,KAAK;SACf;QACD,aAAa,EAAE,EAAE;QACjB,kBAAkB,EAAE,KAAK;QACzB,gBAAgB,EAAE,EAAE;QACpB,eAAe,EAAE,EAAsB;QACvC,gBAAgB,EAAE,EAAwB;QAC1C,eAAe,EAAE,IAAI;QACrB,SAAS,EAAE;YACT,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;YACJ,KAAK,EAAE,EAAE;YACT,gBAAgB,EAAE,EAAE;YACpB,YAAY,EAAE,CAAC;SAChB;QACD,aAAa,EAAE,KAAK;QACpB,WAAW,EAAE;YACX,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;YACJ,QAAQ,EAAE,CAAC;SACZ;QACD,OAAO,EAAE,KAAK;QACd,MAAM,EAAE;YACN,KAAK,EAAE,CAAC,CAAC;YACT,MAAM,EAAE,EAAE;SACX;QACD,WAAW,EAAE;YACX,EAAE,EAAE,IAAI;YACR,OAAO,EAAE,KAAK;YACd,MAAM,EAAE,KAAK;YACb,MAAM,EAAE,EAAE;SACX;QACD,eAAe,EAAE,EAAE;QACnB,eAAe,EAAE,EAAE;QACnB,mBAAmB,EAAE,EAAmD;QACxE,mBAAmB,EAAE,EAAmD;QACxE,0BAA0B,EAAE,EAAE;QAC9B,SAAS,EAAE,KAAK;QAChB,UAAU,EAAE,EAAE;QACd,gBAAgB,EAAE,KAAK;QACvB,oBAAoB,EAAE,IAAI;QAC1B,cAAc,EAAE,EAAsB;QACtC,cAAc,EAAE;YACd,MAAM,EAAE,KAAK;YACb,OAAO,EAAE,GAAG;YACZ,YAAY,EAAE,KAAK;YACnB,UAAU,EAAE,EAAE;SACf;QACD,YAAY,EAAE,KAAK,EAAE,0DAA0D;KAChF,CAAC;IACF,OAAO,EAAE;QACP,uDAAuD;QACvD,2BAA2B,CAAC,KAAK;YAC/B,MAAM,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,GAAG,KAAK,CAAC;YAC3D,MAAM,KAAK,GAAG,mBAAmB,CAAC,GAAG,CAAC,CAAC,cAAc,EAAE,EAAE,CAAC,cAAc,CAAC,EAAE,CAAC,CAAC;YAC7E,MAAM,KAAK,GAAG,mBAAmB,CAAC,GAAG,CAAC,CAAC,cAAc,EAAE,EAAE,CAAC,cAAc,CAAC,EAAE,CAAC,CAAC;YAC7E,OAAO,CAAC,GAAG,IAAI,GAAG,CAAC,CAAC,GAAG,KAAK,EAAE,GAAG,KAAK,CAAC,CAAC,CAAC,CAAC;QAC5C,CAAC;QAED,sDAAsD;QACtD,QAAQ;YACN,OAAO,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,CAAC,MAAM,KAAK,CAAC,IAAI,CAAC,MAAM,CAAC,KAAK,GAAG,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,MAAM,CAAC,CAAC;QACxG,CAAC;KACF;IACD,OAAO,EAAE;QACP,KAAK,CAAC,UAAU;YACd,MAAM,YAAY,GAAG,eAAe,EAAE,CAAC;YACvC,MAAM,SAAS,GAAG,YAAY,CAAC,gBAAgB,CAAC;YAChD,8DAA8D;YAC9D,MAAM,QAAQ,GAAG,MAAM,QAAQ,CAAC,GAAG,CAAC,6BAA6B,SAAS,uBAAuB,EAAE,EAAE,KAAK,EAAE,KAAK,EAAE,CAAC,CAAC,KAAK,CAAC,GAAG,EAAE,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;YAEvI,IAAI,CAAC,KAAK,GAAG,QAAQ,CAAC,KAAK,CAAC;QAC9B,CAAC;QAED,YAAY,CAAC,IAAsB;YACjC,0DAA0D;YAC1D,0DAA0D;YAC1D,MAAM,KAAK,GAAG,IAAI,CAAC,gBAAgB,CAAC,SAAS,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,GAAG,KAAK,IAAI,CAAC,GAAG,CAAC,CAAC;YAC/E,IAAI,KAAK,GAAG,CAAC,CAAC,EAAE;gBACd,IAAI,CAAC,gBAAgB,CAAC,MAAM,CAAC,KAAK,EAAE,CAAC,CAAC,CAAC;aACxC;YAED,IAAI,CAAC,gBAAgB,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QACnC,CAAC;QAED,eAAe,CAAC,IAAsB;YACpC,MAAM,KAAK,GAAG,IAAI,CAAC,gBAAgB,CAAC,SAAS,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,GAAG,KAAK,IAAI,CAAC,GAAG,CAAC,CAAC;YAC/E,IAAI,KAAK,GAAG,CAAC,CAAC,EAAE;gBACd,IAAI,CAAC,gBAAgB,CAAC,MAAM,CAAC,KAAK,EAAE,CAAC,CAAC,CAAC;aACxC;QACH,CAAC;QAED,mBAAmB;YACjB,IAAI,CAAC,gBAAgB,GAAG,EAAE,CAAC;QAC7B,CAAC;QAED,SAAS;YACP,MAAM,EAAE,GAAG,MAAM,EAAE,CAAC;YAEpB,IAAI,CAAC,IAAI,CAAC,EAAE,CAAC,GAAG;gBACd,MAAM,EAAE,IAAI;gBACZ,SAAS,EAAE,CAAC;aACb,CAAC;YAEF,OAAO,EAAE,CAAC;QACZ,CAAC;QAED,SAAS,CAAC,EAAU;YAClB,IAAI,EAAE,KAAK,IAAI,CAAC,WAAW;gBAAE,IAAI,CAAC,WAAW,GAAG,EAAE,CAAC;YACnD,OAAO,IAAI,CAAC,IAAI,CAAC,EAAE,CAAC,CAAC;QACvB,CAAC;QAED,0BAA0B,CAAC,SAAS;YAClC,MAAM,YAAY,GAAG,SAAS,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC,iCAAiC;YACvF,MAAM,YAAY,GAAG,SAAS,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC,iCAAiC;YAEvF,MAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,YAAY,CAAC,CAAC,CAAC,sCAAsC;YAC9E,MAAM,KAAK,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,YAAY,CAAC,CAAC,CAAC,uCAAuC;YAChF,MAAM,KAAK,GAAG,CAAC,KAAK,GAAG,IAAI,CAAC,CAAC;YAE7B,MAAM,GAAG,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,YAAY,CAAC,CAAC,CAAC,qCAAqC;YAC5E,MAAM,MAAM,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,YAAY,CAAC,CAAC,CAAC,wCAAwC;YAClF,MAAM,MAAM,GAAG,CAAC,MAAM,GAAG,GAAG,CAAC,CAAC;YAC9B,OAAO,EAAE,IAAI,EAAE,KAAK,EAAE,KAAK,EAAE,GAAG,EAAE,MAAM,EAAE,MAAM,EAAE,CAAC;QACrD,CAAC;QAED,qBAAqB,CAAC,KAAK;YACzB,IAAI,CAAC,KAAK;gBAAE,OAAO;YACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,QAAQ;gBAAE,OAAO;YAC5D,MAAM,EAAE,SAAS,EAAE,GAAG,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,QAAQ,CAAC;YAChD,IAAI,CAAC,wBAAwB,CAAC,KAAK,EAAE,SAAS,CAAC,CAAC;QAClD,CAAC;QAED,wBAAwB,CAAC,EAAE,EAAE,SAAS;YACpC,IAAI,CAAC,kBAAkB,CAAC,EAAE,EAAE,SAAS,CAAC,CAAC;YACvC,IAAI,CAAC,kBAAkB,CAAC,EAAE,EAAE,SAAS,CAAC,CAAC;QACzC,CAAC;QAED,+BAA+B;QAC/B,kBAAkB,CAAC,EAAE,EAAE,SAAS;YAC9B,MAAM,EAAE,GAAG,EAAE,MAAM,EAAE,GAAG,IAAI,CAAC,0BAA0B,CAAC,SAAS,CAAC,CAAC;YACnE,MAAM,MAAM,GAAG,CAAC,MAAM,GAAG,GAAG,CAAC,GAAG,CAAC,GAAG,GAAG,CAAC,CAAC,wCAAwC;YAEjF,MAAM,oBAAoB,GAAG,EAAE,GAAG,EAAE,MAAM,EAAE,MAAM,EAAE,CAAC;YACrD,IAAI,CAAC,aAAa,CAAC,EAAE,EAAE,iBAAiB,EAAE,oBAAoB,CAAC,CAAC;QAClE,CAAC;QAED,4BAA4B;QAC5B,kBAAkB,CAAC,EAAE,EAAE,SAAS;YAC9B,MAAM,EAAE,IAAI,EAAE,KAAK,EAAE,GAAG,IAAI,CAAC,0BAA0B,CAAC,SAAS,CAAC,CAAC;YACnE,MAAM,MAAM,GAAG,CAAC,KAAK,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,IAAI,CAAC,CAAC,wCAAwC;YAElF,MAAM,oBAAoB,GAAG,EAAE,IAAI,EAAE,MAAM,EAAE,KAAK,EAAE,CAAC;YACrD,IAAI,CAAC,aAAa,CAAC,EAAE,EAAE,iBAAiB,EAAE,oBAAoB,CAAC,CAAC;QAClE,CAAC;QAED,mBAAmB,CAAC,EAAE;YACpB,OAAO,IAAI,CAAC,eAAe,CAAC,EAAE,CAAC,CAAC;YAChC,OAAO,IAAI,CAAC,eAAe,CAAC,EAAE,CAAC,CAAC;QAClC,CAAC;QAED,wBAAwB,CAAC,QAAQ;YAC/B,MAAM,cAAc,GAAG,EAAE,GAAG,IAAI,CAAC,QAAQ,CAAC,EAAE,CAAC;YAE7C,8DAA8D;YAC9D,IAAI,CAAC,aAAa,CAAC,OAAO,CAAC,CAAC,MAAM,EAAE,EAAE;gBACpC,OAAO,cAAc,CAAC,MAAM,CAAC,CAAC;YAChC,CAAC,CAAC,CAAC;YAEH,iCAAiC;YACjC,MAAM,UAAU,GAAG,MAAM,CAAC,IAAI,CAAC,cAAc,CAAC;iBAC3C,MAAM,CAAC,CAAC,GAAG,EAAE,EAAE,CAAC,GAAG,CAAC,WAAW,EAAE,CAAC,QAAQ,CAAC,IAAI,CAAC,WAAW,CAAC,WAAW,EAAE,CAAC,CAAC;iBAC3E,MAAM,CAAC,CAAC,GAAG,EAAE,GAAG,EAAE,EAAE,CAAC,CAAC;gBACrB,GAAG,GAAG;gBACN,CAAC,GAAG,CAAC,EAAE,cAAc,CAAC,GAAG,CAAC;aAC3B,CAAC,EAAE,EAAE,CAAC,CAAC;YACV,OAAO,UAAU,IAAI,EAAE,CAAC;QAC1B,CAAC;QAED,uBAAuB,CAAC,CAAC,EAAE,CAAC,EAAE,YAAY;YACxC,MAAM,EAAE,KAAK,EAAE,MAAM,EAAE,GAAG,IAAI,CAAC,0BAA0B,CAAC,YAAY,CAAC,CAAC;YAExE,MAAM,WAAW,GAAG,CAAC,CAAC,CAAC,sCAAsC;YAC7D,MAAM,eAAe,GAAG,IAAI,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,CAAC;YACzE,MAAM,eAAe,GAAG,IAAI,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,CAAC;YAEzE,MAAM,mBAAmB,GAAG,EAAE,CAAC;YAC/B,MAAM,mBAAmB,GAAG,EAAE,CAAC;YAE/B,MAAM,UAAU,GAAG,MAAM,GAAG,GAAG,CAAC;YAChC,MAAM,SAAS,GAAG,CAAC,GAAG,UAAU,CAAC;YACjC,MAAM,YAAY,GAAG,CAAC,CAAC;YACvB,MAAM,YAAY,GAAG,CAAC,GAAG,UAAU,CAAC;YAEpC,MAAM,SAAS,GAAG,KAAK,GAAG,GAAG,CAAC;YAC9B,MAAM,UAAU,GAAG,CAAC,GAAG,SAAS,CAAC;YACjC,MAAM,YAAY,GAAG,CAAC,CAAC;YACvB,MAAM,WAAW,GAAG,CAAC,GAAG,SAAS,CAAC;YAElC,uEAAuE;YACvE,MAAM,CAAC,IAAI,CAAC,eAAe,CAAC,CAAC,OAAO,CAAC,CAAC,GAAG,EAAE,EAAE;gBAC3C,MAAM,SAAS,GAAG,eAAe,CAAC,GAAG,CAAC,CAAC;gBACvC,MAAM,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC,OAAO,CAAC,CAAC,CAAC,EAAE,EAAE;oBACnC,CAAC,SAAS,EAAE,YAAY,EAAE,YAAY,CAAC,CAAC,OAAO,CAAC,CAAC,KAAK,EAAE,EAAE;wBACxD,MAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,KAAK,GAAG,SAAS,CAAC,CAAC,CAAC,CAAC,CAAC;wBAC5C,IAAI,IAAI,GAAG,WAAW,EAAE;4BACtB,mBAAmB,CAAC,IAAI,CAAC,EAAE,EAAE,EAAE,GAAG,EAAE,IAAI,EAAE,SAAS,CAAC,CAAC,CAAC,EAAE,KAAK,EAAE,SAAS,EAAE,CAAC,CAAC;yBAC7E;oBACH,CAAC,CAAC,CAAC;gBACL,CAAC,CAAC,CAAC;YACL,CAAC,CAAC,CAAC;YAEH,uEAAuE;YACvE,MAAM,CAAC,IAAI,CAAC,eAAe,CAAC,CAAC,OAAO,CAAC,CAAC,GAAG,EAAE,EAAE;gBAC3C,MAAM,SAAS,GAAG,eAAe,CAAC,GAAG,CAAC,CAAC;gBACvC,MAAM,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC,OAAO,CAAC,CAAC,CAAC,EAAE,EAAE;oBACnC,CAAC,UAAU,EAAE,YAAY,EAAE,WAAW,CAAC,CAAC,OAAO,CAAC,CAAC,KAAK,EAAE,EAAE;wBACxD,MAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,KAAK,GAAG,SAAS,CAAC,CAAC,CAAC,CAAC,CAAC;wBAC5C,IAAI,IAAI,GAAG,WAAW,EAAE;4BACtB,mBAAmB,CAAC,IAAI,CAAC,EAAE,EAAE,EAAE,GAAG,EAAE,IAAI,EAAE,SAAS,CAAC,CAAC,CAAC,EAAE,KAAK,EAAE,SAAS,EAAE,CAAC,CAAC;yBAC7E;oBACH,CAAC,CAAC,CAAC;gBACL,CAAC,CAAC,CAAC;YACL,CAAC,CAAC,CAAC;YACH,IAAI,CAAC,mBAAmB,GAAG,mBAAmB,CAAC;YAC/C,IAAI,CAAC,mBAAmB,GAAG,mBAAmB,CAAC;QACjD,CAAC;QAED;;;;;WAKG;QACH,aAAa,CAAC,GAAG,EAAE,IAAI,EAAE,WAAW;YAClC,IAAI,GAAG,IAAI,IAAI,CAAC,IAAI,CAAC,EAAE;gBACrB,IAAI,CAAC,IAAI,CAAC,CAAC,GAAG,CAAC,GAAG,WAAW,CAAC;aAC/B;iBAAM;gBACL,IAAI,CAAC,IAAI,CAAC,GAAG;oBACX,GAAG,IAAI,CAAC,IAAI,CAAC;oBACb,CAAC,GAAG,CAAC,EAAE,WAAW;iBACnB,CAAC;aACH;QACH,CAAC;KACF;CACF,CAAC,CAAC;AAEH,eAAe,cAAc,CAAC",
      sourcesContent: ["import { nanoid } from 'nanoid';\nimport { defineStore } from 'pinia';\nimport { requests } from '@/common/plugins/axios';\nimport { IApp, IHighlightedNode } from '@/views/creatives/interfaces';\nimport { useCompanyStore } from './company';\n\ninterface IExportSession {\n  creativeId: string;\n  status: 'QUEUED'|'IN_PROGRESS'|'COMPLETED'|'FAILED';\n  session: string; // 'Gfv8Zj6p6bB9nsqqsV1oJ'\n  route: string; // 'creatives/exports/canvas'\n  data?: {\n    url: string;\n    id?: string; // \"1984845351\"\n    message?:string;\n    status?: string;\n  };\n}\n\nexport const useEditorStore = defineStore('editor', {\n  state: () => ({\n    apps: {} as { [key: string]: IApp },\n    fonts: [], // list of custom fonts for company\n    activeAppId: '', // current active ad (Landscape/Portrait)\n    activeArtBoardId: '',\n    zoomScale: 1, // current editor zoom scale\n    interactions: { // keeping track of the interactions in editor\n      move: false,\n      pan: false,\n      zoom: false,\n      resize: false,\n      transform: false,\n      updates: false,\n    },\n    selectedNodes: [], // array of unique ids of selected nodes\n    triggerTransformer: false, // trigger a reposition for the transformer\n    highlightedLayer: '', // reference to the layer that is currently hovered over in Play Left drawer and Canvas editor view\n    highlightedNode: {} as IHighlightedNode, // used when moving a layer with keyboard\n    highlightedNodes: [] as IHighlightedNode[],\n    showTransformer: true, // flag to show transformer\n    layerMove: { // used when moving a layer with keyboard\n      x: 0,\n      y: 0,\n      state: '',\n      boardOrientation: '',\n      forceTrigger: 0,\n    },\n    isMultiSelect: false, // is the user holding down the shift/ctrl key\n    transformer: { // used when updating transformer position for guidelines\n      x: 0,\n      y: 0,\n      rotation: 0,\n    },\n    rulerOn: false, // boolean to show UI canvas ruler\n    layers: { // total number of layers for current scene for currentCreative in creativeStore\n      total: -1,\n      loaded: {},\n    },\n    sortingData: {\n      id: null,\n      cleared: false,\n      moving: false,\n      states: {},\n    },\n    xAxisGuidelines: {},\n    yAxisGuidelines: {},\n    drawXAxisGuidelines: [] as { id: string; draw: number; color: string }[],\n    drawYAxisGuidelines: [] as { id: string; draw: number; color: string }[],\n    guidelineHighlightedLayers: [],\n    zoomToFit: false,\n    editableId: '',\n    istextEditorOpen: false, // instance editorTextInput\n    exportSessionsNotify: null,\n    exportSessions: [] as IExportSession[],\n    exportSettings: {\n      format: 'png',\n      quality: 100,\n      transparency: false,\n      resolution: 72,\n    }, // The export settings for this creative, dpi, format and quality.\n    reloadEditor: false, // used to refresh the editor area after a big data change\n  }),\n  getters: {\n    // used to highlight intersecting nodes with guidelines\n    getGuidelinesNodeIntersects(state) {\n      const { drawXAxisGuidelines, drawYAxisGuidelines } = state;\n      const xAxis = drawXAxisGuidelines.map((xAxisGuideline) => xAxisGuideline.id);\n      const yAxis = drawYAxisGuidelines.map((yAxisGuideline) => yAxisGuideline.id);\n      return [...new Set([...xAxis, ...yAxis])];\n    },\n\n    // boolean flag to determine if all layers have loaded\n    isLoaded(): boolean {\n      return Object.keys(this.layers.loaded).length === (this.layers.total * Object.keys(this.apps).length);\n    },\n  },\n  actions: {\n    async fetchFonts(): Promise<void> {\n      const companyStore = useCompanyStore();\n      const companyId = companyStore.currentCompanyId;\n      // do we need all fonts or just the ones used in the creative?\n      const response = await requests.get(`/assets/library?companies=${companyId}&q=type:contains:font`, { cache: false }).catch(() => ({}));\n\n      this.fonts = response.items;\n    },\n\n    addHighlight(node: IHighlightedNode) {\n      // if the node.uid is found in highlightedNodes, remove it\n      // then, add the new node to the list of highlightedNodes.\n      const index = this.highlightedNodes.findIndex((item) => item.uid === node.uid);\n      if (index > -1) {\n        this.highlightedNodes.splice(index, 1);\n      }\n\n      this.highlightedNodes.push(node);\n    },\n\n    removeHighlight(node: IHighlightedNode) {\n      const index = this.highlightedNodes.findIndex((item) => item.uid === node.uid);\n      if (index > -1) {\n        this.highlightedNodes.splice(index, 1);\n      }\n    },\n\n    removeAllHighlights() {\n      this.highlightedNodes = [];\n    },\n\n    createApp() {\n      const id = nanoid();\n\n      this.apps[id] = {\n        canvas: null,\n        zoomScale: 1,\n      };\n\n      return id;\n    },\n\n    removeApp(id: string) {\n      if (id === this.activeAppId) this.activeAppId = '';\n      delete this.apps[id];\n    },\n\n    getCoordinatesFromPosition(positions) {\n      const xCoordinates = positions.map((item) => item.x); // only looking for X coordinates\n      const yCoordinates = positions.map((item) => item.y); // only looking for Y coordinates\n\n      const left = Math.min(...xCoordinates); // minimum X value closest to the left\n      const right = Math.max(...xCoordinates); // maximum X value closest to the right\n      const width = (right - left);\n\n      const top = Math.min(...yCoordinates); // minimum Y value closest to the top\n      const bottom = Math.max(...yCoordinates); // maximum Y value closest to the bottom\n      const height = (bottom - top);\n      return { left, right, width, top, bottom, height };\n    },\n\n    setArtboardGuidelines(appId) {\n      if (!appId) return;\n      if (!this.apps[appId] || !this.apps[appId].artBoard) return;\n      const { positions } = this.apps[appId].artBoard;\n      this.updateGuidelinesPosition(appId, positions);\n    },\n\n    updateGuidelinesPosition(id, positions) {\n      this.setXAxisGuidelines(id, positions);\n      this.setYAxisGuidelines(id, positions);\n    },\n\n    // set horizontals guidelines \u2014\n    setXAxisGuidelines(id, positions) {\n      const { top, bottom } = this.getCoordinatesFromPosition(positions);\n      const middle = (bottom - top) / 2 + top; // middle Y value between top and bottom\n\n      const guidelineCoordinates = { top, middle, bottom };\n      this.setGuidelines(id, 'xAxisGuidelines', guidelineCoordinates);\n    },\n\n    // set vertical guidelines |\n    setYAxisGuidelines(id, positions) {\n      const { left, right } = this.getCoordinatesFromPosition(positions);\n      const center = (right - left) / 2 + left; // middle X value between left and right\n\n      const guidelineCoordinates = { left, center, right };\n      this.setGuidelines(id, 'yAxisGuidelines', guidelineCoordinates);\n    },\n\n    removeGuidelinebyId(id) {\n      delete this.xAxisGuidelines[id];\n      delete this.yAxisGuidelines[id];\n    },\n\n    getCurrentAxisGuidelines(property) {\n      const axisGuidelines = { ...this[property] };\n\n      // remove guidelines that are for the currently selected nodes\n      this.selectedNodes.forEach((nodeId) => {\n        delete axisGuidelines[nodeId];\n      });\n\n      // get only active app guidelines\n      const guidelines = Object.keys(axisGuidelines)\n        .filter((key) => key.toLowerCase().includes(this.activeAppId.toLowerCase()))\n        .reduce((obj, key) => ({\n          ...obj,\n          [key]: axisGuidelines[key],\n        }), {});\n      return guidelines || {};\n    },\n\n    updateVisibleGuidelines(x, y, globalPoints) {\n      const { width, height } = this.getCoordinatesFromPosition(globalPoints);\n\n      const currentDiff = 3; // distance from other value threshold\n      const xAxisGuidelines = this.getCurrentAxisGuidelines('xAxisGuidelines');\n      const yAxisGuidelines = this.getCurrentAxisGuidelines('yAxisGuidelines');\n\n      const drawXAxisGuidelines = [];\n      const drawYAxisGuidelines = [];\n\n      const halfHeight = height * 0.5;\n      const objectTop = y - halfHeight;\n      const objectMiddle = y;\n      const objectBottom = y + halfHeight;\n\n      const halfWidth = width * 0.5;\n      const objectLeft = x - halfWidth;\n      const objectCenter = x;\n      const objectRight = x + halfWidth;\n\n      // check if top middle or bottom of the object is within any guidelines\n      Object.keys(xAxisGuidelines).forEach((key) => {\n        const guideline = xAxisGuidelines[key];\n        Object.keys(guideline).forEach((k) => {\n          [objectTop, objectMiddle, objectBottom].forEach((value) => {\n            const diff = Math.abs(value - guideline[k]);\n            if (diff < currentDiff) {\n              drawXAxisGuidelines.push({ id: key, draw: guideline[k], color: '#00B0FF' });\n            }\n          });\n        });\n      });\n\n      // check if left middle or right of the object is within any guidelines\n      Object.keys(yAxisGuidelines).forEach((key) => {\n        const guideline = yAxisGuidelines[key];\n        Object.keys(guideline).forEach((k) => {\n          [objectLeft, objectCenter, objectRight].forEach((value) => {\n            const diff = Math.abs(value - guideline[k]);\n            if (diff < currentDiff) {\n              drawYAxisGuidelines.push({ id: key, draw: guideline[k], color: '#00B0FF' });\n            }\n          });\n        });\n      });\n      this.drawXAxisGuidelines = drawXAxisGuidelines;\n      this.drawYAxisGuidelines = drawYAxisGuidelines;\n    },\n\n    /**\n     * helper function to set guidelines in axis map\n     * @param key => This can be a node id or artboard\n     * @param axis => The pinia state property you want to assign to ['xAxisGuidelines','yAxisGuidelines']\n     * @param coordinates => The values you wish to assign {top, middle, bottom, etc}\n     */\n    setGuidelines(key, axis, coordinates) {\n      if (key in this[axis]) {\n        this[axis][key] = coordinates;\n      } else {\n        this[axis] = {\n          ...this[axis],\n          [key]: coordinates,\n        };\n      }\n    },\n  },\n});\n\nexport default useEditorStore;\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4271894c242b18a8e9ae06f90eb2f68a5b2045de"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15r8fybm8s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15r8fybm8s();
import "core-js/modules/es.array.push.js";
import { nanoid } from 'nanoid';
import { defineStore } from 'pinia';
import { requests } from '@/common/plugins/axios';
import { useCompanyStore } from './company';
export const useEditorStore = (cov_15r8fybm8s().s[0]++, defineStore('editor', {
  state: () => {
    cov_15r8fybm8s().f[0]++;
    cov_15r8fybm8s().s[1]++;
    return {
      apps: {},
      fonts: [],
      activeAppId: '',
      activeArtBoardId: '',
      zoomScale: 1,
      interactions: {
        move: false,
        pan: false,
        zoom: false,
        resize: false,
        transform: false,
        updates: false
      },
      selectedNodes: [],
      triggerTransformer: false,
      highlightedLayer: '',
      highlightedNode: {},
      highlightedNodes: [],
      showTransformer: true,
      layerMove: {
        x: 0,
        y: 0,
        state: '',
        boardOrientation: '',
        forceTrigger: 0
      },
      isMultiSelect: false,
      transformer: {
        x: 0,
        y: 0,
        rotation: 0
      },
      rulerOn: false,
      layers: {
        total: -1,
        loaded: {}
      },
      sortingData: {
        id: null,
        cleared: false,
        moving: false,
        states: {}
      },
      xAxisGuidelines: {},
      yAxisGuidelines: {},
      drawXAxisGuidelines: [],
      drawYAxisGuidelines: [],
      guidelineHighlightedLayers: [],
      zoomToFit: false,
      editableId: '',
      istextEditorOpen: false,
      exportSessionsNotify: null,
      exportSessions: [],
      exportSettings: {
        format: 'png',
        quality: 100,
        transparency: false,
        resolution: 72
      },
      reloadEditor: false // used to refresh the editor area after a big data change
    };
  },

  getters: {
    // used to highlight intersecting nodes with guidelines
    getGuidelinesNodeIntersects(state) {
      cov_15r8fybm8s().f[1]++;
      const {
        drawXAxisGuidelines,
        drawYAxisGuidelines
      } = (cov_15r8fybm8s().s[2]++, state);
      const xAxis = (cov_15r8fybm8s().s[3]++, drawXAxisGuidelines.map(xAxisGuideline => {
        cov_15r8fybm8s().f[2]++;
        cov_15r8fybm8s().s[4]++;
        return xAxisGuideline.id;
      }));
      const yAxis = (cov_15r8fybm8s().s[5]++, drawYAxisGuidelines.map(yAxisGuideline => {
        cov_15r8fybm8s().f[3]++;
        cov_15r8fybm8s().s[6]++;
        return yAxisGuideline.id;
      }));
      cov_15r8fybm8s().s[7]++;
      return [...new Set([...xAxis, ...yAxis])];
    },
    // boolean flag to determine if all layers have loaded
    isLoaded() {
      cov_15r8fybm8s().f[4]++;
      cov_15r8fybm8s().s[8]++;
      return Object.keys(this.layers.loaded).length === this.layers.total * Object.keys(this.apps).length;
    }
  },
  actions: {
    async fetchFonts() {
      cov_15r8fybm8s().f[5]++;
      const companyStore = (cov_15r8fybm8s().s[9]++, useCompanyStore());
      const companyId = (cov_15r8fybm8s().s[10]++, companyStore.currentCompanyId);
      // do we need all fonts or just the ones used in the creative?
      const response = (cov_15r8fybm8s().s[11]++, await requests.get(`/assets/library?companies=${companyId}&q=type:contains:font`, {
        cache: false
      }).catch(() => {
        cov_15r8fybm8s().f[6]++;
        cov_15r8fybm8s().s[12]++;
        return {};
      }));
      cov_15r8fybm8s().s[13]++;
      this.fonts = response.items;
    },
    addHighlight(node) {
      cov_15r8fybm8s().f[7]++;
      // if the node.uid is found in highlightedNodes, remove it
      // then, add the new node to the list of highlightedNodes.
      const index = (cov_15r8fybm8s().s[14]++, this.highlightedNodes.findIndex(item => {
        cov_15r8fybm8s().f[8]++;
        cov_15r8fybm8s().s[15]++;
        return item.uid === node.uid;
      }));
      cov_15r8fybm8s().s[16]++;
      if (index > -1) {
        cov_15r8fybm8s().b[0][0]++;
        cov_15r8fybm8s().s[17]++;
        this.highlightedNodes.splice(index, 1);
      } else {
        cov_15r8fybm8s().b[0][1]++;
      }
      cov_15r8fybm8s().s[18]++;
      this.highlightedNodes.push(node);
    },
    removeHighlight(node) {
      cov_15r8fybm8s().f[9]++;
      const index = (cov_15r8fybm8s().s[19]++, this.highlightedNodes.findIndex(item => {
        cov_15r8fybm8s().f[10]++;
        cov_15r8fybm8s().s[20]++;
        return item.uid === node.uid;
      }));
      cov_15r8fybm8s().s[21]++;
      if (index > -1) {
        cov_15r8fybm8s().b[1][0]++;
        cov_15r8fybm8s().s[22]++;
        this.highlightedNodes.splice(index, 1);
      } else {
        cov_15r8fybm8s().b[1][1]++;
      }
    },
    removeAllHighlights() {
      cov_15r8fybm8s().f[11]++;
      cov_15r8fybm8s().s[23]++;
      this.highlightedNodes = [];
    },
    createApp() {
      cov_15r8fybm8s().f[12]++;
      const id = (cov_15r8fybm8s().s[24]++, nanoid());
      cov_15r8fybm8s().s[25]++;
      this.apps[id] = {
        canvas: null,
        zoomScale: 1
      };
      cov_15r8fybm8s().s[26]++;
      return id;
    },
    removeApp(id) {
      cov_15r8fybm8s().f[13]++;
      cov_15r8fybm8s().s[27]++;
      if (id === this.activeAppId) {
        cov_15r8fybm8s().b[2][0]++;
        cov_15r8fybm8s().s[28]++;
        this.activeAppId = '';
      } else {
        cov_15r8fybm8s().b[2][1]++;
      }
      cov_15r8fybm8s().s[29]++;
      delete this.apps[id];
    },
    getCoordinatesFromPosition(positions) {
      cov_15r8fybm8s().f[14]++;
      const xCoordinates = (cov_15r8fybm8s().s[30]++, positions.map(item => {
        cov_15r8fybm8s().f[15]++;
        cov_15r8fybm8s().s[31]++;
        return item.x;
      })); // only looking for X coordinates
      const yCoordinates = (cov_15r8fybm8s().s[32]++, positions.map(item => {
        cov_15r8fybm8s().f[16]++;
        cov_15r8fybm8s().s[33]++;
        return item.y;
      })); // only looking for Y coordinates
      const left = (cov_15r8fybm8s().s[34]++, Math.min(...xCoordinates)); // minimum X value closest to the left
      const right = (cov_15r8fybm8s().s[35]++, Math.max(...xCoordinates)); // maximum X value closest to the right
      const width = (cov_15r8fybm8s().s[36]++, right - left);
      const top = (cov_15r8fybm8s().s[37]++, Math.min(...yCoordinates)); // minimum Y value closest to the top
      const bottom = (cov_15r8fybm8s().s[38]++, Math.max(...yCoordinates)); // maximum Y value closest to the bottom
      const height = (cov_15r8fybm8s().s[39]++, bottom - top);
      cov_15r8fybm8s().s[40]++;
      return {
        left,
        right,
        width,
        top,
        bottom,
        height
      };
    },
    setArtboardGuidelines(appId) {
      cov_15r8fybm8s().f[17]++;
      cov_15r8fybm8s().s[41]++;
      if (!appId) {
        cov_15r8fybm8s().b[3][0]++;
        cov_15r8fybm8s().s[42]++;
        return;
      } else {
        cov_15r8fybm8s().b[3][1]++;
      }
      cov_15r8fybm8s().s[43]++;
      if ((cov_15r8fybm8s().b[5][0]++, !this.apps[appId]) || (cov_15r8fybm8s().b[5][1]++, !this.apps[appId].artBoard)) {
        cov_15r8fybm8s().b[4][0]++;
        cov_15r8fybm8s().s[44]++;
        return;
      } else {
        cov_15r8fybm8s().b[4][1]++;
      }
      const {
        positions
      } = (cov_15r8fybm8s().s[45]++, this.apps[appId].artBoard);
      cov_15r8fybm8s().s[46]++;
      this.updateGuidelinesPosition(appId, positions);
    },
    updateGuidelinesPosition(id, positions) {
      cov_15r8fybm8s().f[18]++;
      cov_15r8fybm8s().s[47]++;
      this.setXAxisGuidelines(id, positions);
      cov_15r8fybm8s().s[48]++;
      this.setYAxisGuidelines(id, positions);
    },
    // set horizontals guidelines —
    setXAxisGuidelines(id, positions) {
      cov_15r8fybm8s().f[19]++;
      const {
        top,
        bottom
      } = (cov_15r8fybm8s().s[49]++, this.getCoordinatesFromPosition(positions));
      const middle = (cov_15r8fybm8s().s[50]++, (bottom - top) / 2 + top); // middle Y value between top and bottom
      const guidelineCoordinates = (cov_15r8fybm8s().s[51]++, {
        top,
        middle,
        bottom
      });
      cov_15r8fybm8s().s[52]++;
      this.setGuidelines(id, 'xAxisGuidelines', guidelineCoordinates);
    },
    // set vertical guidelines |
    setYAxisGuidelines(id, positions) {
      cov_15r8fybm8s().f[20]++;
      const {
        left,
        right
      } = (cov_15r8fybm8s().s[53]++, this.getCoordinatesFromPosition(positions));
      const center = (cov_15r8fybm8s().s[54]++, (right - left) / 2 + left); // middle X value between left and right
      const guidelineCoordinates = (cov_15r8fybm8s().s[55]++, {
        left,
        center,
        right
      });
      cov_15r8fybm8s().s[56]++;
      this.setGuidelines(id, 'yAxisGuidelines', guidelineCoordinates);
    },
    removeGuidelinebyId(id) {
      cov_15r8fybm8s().f[21]++;
      cov_15r8fybm8s().s[57]++;
      delete this.xAxisGuidelines[id];
      cov_15r8fybm8s().s[58]++;
      delete this.yAxisGuidelines[id];
    },
    getCurrentAxisGuidelines(property) {
      cov_15r8fybm8s().f[22]++;
      const axisGuidelines = (cov_15r8fybm8s().s[59]++, {
        ...this[property]
      });
      // remove guidelines that are for the currently selected nodes
      cov_15r8fybm8s().s[60]++;
      this.selectedNodes.forEach(nodeId => {
        cov_15r8fybm8s().f[23]++;
        cov_15r8fybm8s().s[61]++;
        delete axisGuidelines[nodeId];
      });
      // get only active app guidelines
      const guidelines = (cov_15r8fybm8s().s[62]++, Object.keys(axisGuidelines).filter(key => {
        cov_15r8fybm8s().f[24]++;
        cov_15r8fybm8s().s[63]++;
        return key.toLowerCase().includes(this.activeAppId.toLowerCase());
      }).reduce((obj, key) => {
        cov_15r8fybm8s().f[25]++;
        cov_15r8fybm8s().s[64]++;
        return {
          ...obj,
          [key]: axisGuidelines[key]
        };
      }, {}));
      cov_15r8fybm8s().s[65]++;
      return (cov_15r8fybm8s().b[6][0]++, guidelines) || (cov_15r8fybm8s().b[6][1]++, {});
    },
    updateVisibleGuidelines(x, y, globalPoints) {
      cov_15r8fybm8s().f[26]++;
      const {
        width,
        height
      } = (cov_15r8fybm8s().s[66]++, this.getCoordinatesFromPosition(globalPoints));
      const currentDiff = (cov_15r8fybm8s().s[67]++, 3); // distance from other value threshold
      const xAxisGuidelines = (cov_15r8fybm8s().s[68]++, this.getCurrentAxisGuidelines('xAxisGuidelines'));
      const yAxisGuidelines = (cov_15r8fybm8s().s[69]++, this.getCurrentAxisGuidelines('yAxisGuidelines'));
      const drawXAxisGuidelines = (cov_15r8fybm8s().s[70]++, []);
      const drawYAxisGuidelines = (cov_15r8fybm8s().s[71]++, []);
      const halfHeight = (cov_15r8fybm8s().s[72]++, height * 0.5);
      const objectTop = (cov_15r8fybm8s().s[73]++, y - halfHeight);
      const objectMiddle = (cov_15r8fybm8s().s[74]++, y);
      const objectBottom = (cov_15r8fybm8s().s[75]++, y + halfHeight);
      const halfWidth = (cov_15r8fybm8s().s[76]++, width * 0.5);
      const objectLeft = (cov_15r8fybm8s().s[77]++, x - halfWidth);
      const objectCenter = (cov_15r8fybm8s().s[78]++, x);
      const objectRight = (cov_15r8fybm8s().s[79]++, x + halfWidth);
      // check if top middle or bottom of the object is within any guidelines
      cov_15r8fybm8s().s[80]++;
      Object.keys(xAxisGuidelines).forEach(key => {
        cov_15r8fybm8s().f[27]++;
        const guideline = (cov_15r8fybm8s().s[81]++, xAxisGuidelines[key]);
        cov_15r8fybm8s().s[82]++;
        Object.keys(guideline).forEach(k => {
          cov_15r8fybm8s().f[28]++;
          cov_15r8fybm8s().s[83]++;
          [objectTop, objectMiddle, objectBottom].forEach(value => {
            cov_15r8fybm8s().f[29]++;
            const diff = (cov_15r8fybm8s().s[84]++, Math.abs(value - guideline[k]));
            cov_15r8fybm8s().s[85]++;
            if (diff < currentDiff) {
              cov_15r8fybm8s().b[7][0]++;
              cov_15r8fybm8s().s[86]++;
              drawXAxisGuidelines.push({
                id: key,
                draw: guideline[k],
                color: '#00B0FF'
              });
            } else {
              cov_15r8fybm8s().b[7][1]++;
            }
          });
        });
      });
      // check if left middle or right of the object is within any guidelines
      cov_15r8fybm8s().s[87]++;
      Object.keys(yAxisGuidelines).forEach(key => {
        cov_15r8fybm8s().f[30]++;
        const guideline = (cov_15r8fybm8s().s[88]++, yAxisGuidelines[key]);
        cov_15r8fybm8s().s[89]++;
        Object.keys(guideline).forEach(k => {
          cov_15r8fybm8s().f[31]++;
          cov_15r8fybm8s().s[90]++;
          [objectLeft, objectCenter, objectRight].forEach(value => {
            cov_15r8fybm8s().f[32]++;
            const diff = (cov_15r8fybm8s().s[91]++, Math.abs(value - guideline[k]));
            cov_15r8fybm8s().s[92]++;
            if (diff < currentDiff) {
              cov_15r8fybm8s().b[8][0]++;
              cov_15r8fybm8s().s[93]++;
              drawYAxisGuidelines.push({
                id: key,
                draw: guideline[k],
                color: '#00B0FF'
              });
            } else {
              cov_15r8fybm8s().b[8][1]++;
            }
          });
        });
      });
      cov_15r8fybm8s().s[94]++;
      this.drawXAxisGuidelines = drawXAxisGuidelines;
      cov_15r8fybm8s().s[95]++;
      this.drawYAxisGuidelines = drawYAxisGuidelines;
    },
    /**
     * helper function to set guidelines in axis map
     * @param key => This can be a node id or artboard
     * @param axis => The pinia state property you want to assign to ['xAxisGuidelines','yAxisGuidelines']
     * @param coordinates => The values you wish to assign {top, middle, bottom, etc}
     */
    setGuidelines(key, axis, coordinates) {
      cov_15r8fybm8s().f[33]++;
      cov_15r8fybm8s().s[96]++;
      if (key in this[axis]) {
        cov_15r8fybm8s().b[9][0]++;
        cov_15r8fybm8s().s[97]++;
        this[axis][key] = coordinates;
      } else {
        cov_15r8fybm8s().b[9][1]++;
        cov_15r8fybm8s().s[98]++;
        this[axis] = {
          ...this[axis],
          [key]: coordinates
        };
      }
    }
  }
}));
export default useEditorStore;